import './vehicleList.css';
const VehicleList = () => {
    return(
        <div className={'data-table vehicle-list-table font-15'}>
            <ul className="table-row sf-medium light-back border-radius-8">
                <li className={'number-plate'}>Number Plate</li>
                <li className={'vehicle-type'}>Vehicle Type</li>
                <li className={'model'}>Manufacturer/Model</li>
                <li className={'avg-speed'}>Avg Speed</li>
            </ul>

            {
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((vehicle) =>
                    <ul key={vehicle} className="table-row padding-tb-5 border-bottom">
                        <li className={'number-plate'}>KA 02 N 9023</li>
                        <li className={'vehicle-type'}>HMV</li>
                        <li className={'model'}>BharathBenz/2017 HDT R - 30 Tons</li>
                        <li className={'avg-speed highlight-color'}>19 Km/h</li>
                    </ul>
                )
            }

        </div>
    )
}

export default VehicleList;
